/**
 * Created by hp on 2017/5/25.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import {LoadMore} from 'react-weui';

class ClassroomRedpackUserDialog extends Component {
    constructor() {
        super();
        this.onHideUserDialog = this.onHideUserDialog.bind(this);
        this.onPreventProp = this.onPreventProp.bind(this);
        this.onScrollHandle = this.onScrollHandle.bind(this);
    }

    onScrollHandle(e) {
        let {lecture, message, redpackUserObject} = this.props;

        let eleTotalHeight = e.target.scrollHeight;
        let eleOffset = e.target.scrollTop;
        let eleContainHeight = e.target.clientHeight;

        if (eleTotalHeight - eleContainHeight - eleOffset === 0 && redpackUserObject.has_more) {
            let listUrl = `/api/classroom/${lecture.id}/redpack/${message.meta.redpack_id}/record?offset=${redpackUserObject.next_offset}`;
            axios.get(listUrl).then((res) => {
                let records = [...redpackUserObject.records, ...res.data.data.records];
                this.props.dispatch({
                    type: 'SET_REDPACK_USER_OBJECT',
                    preload: Object.assign(res.data.data, {records: records})
                });
            });
        }
    }

    onPreventProp(e) {
        e.stopPropagation();
    }


    onHideUserDialog() {
        this.props.dispatch({
            type: 'HIDE_REDPACK_USER_DIALOG'
        })
    }

    render() {
        let {redpackUserObject, redpackGrab, showRedpackUserDialog} = this.props;
        if (!showRedpackUserDialog) {
            return null;
        }

        return (
            <div className="dialog dialog-redpack-receive" onClick={this.onHideUserDialog}>
                <div className="dialog-redpack-content" onClick={this.onPreventProp}>
                    <div className="nav-bar-redpack">
                        <p>拼手气红包
                            <a className="redpack-close" style={{color: "#fff"}}
                               onClick={this.onHideUserDialog}>关闭</a>
                        </p>
                    </div>
                    <div className="redpack-content-head item-padding">
                        <div className="portrait">
                            <img src={redpackGrab.sender_headimgurl} alt=""/>
                        </div>
                        <p className="margin-top">来自{redpackGrab.sender_nickname}</p>
                        <p className="description text-ellipsis">{redpackGrab.description}</p>
                    </div>
                    <p className="text-minor margin-top">
                        领取{redpackGrab.total_count - redpackGrab.available_count}／{redpackGrab.total_count}个，共{redpackGrab.total_fee / 100}元
                    </p>

                    <div className="receive-list margin-top" style={{maxHeight: "232px", overflowY: "scroll"}}
                         onScroll={this.onScrollHandle}>
                        {redpackUserObject.records.map((item, index) => (
                            <div className="weui-flex weui-padding border-line" key={item.id}>
                                <div className="weui-flex__item flex_1">
                                    <div className="portrait" style={{width: "30px", height: "30px"}}>
                                        <img src={item.account.small_avatar_url} alt=""/>
                                    </div>
                                </div>
                                <div className="weui-flex__item flex_4 text-left overflow-hidden padding-left">
                                    <p>{item.account.nickname}</p>
                                    <p className="text-minor">{item.grab_time}</p>
                                </div>
                                <div className="weui-flex__item flex_1">{item.fee / 100}元</div>
                            </div>
                        ))}
                        {redpackUserObject.has_more &&
                        <div style={{paddingBottom: '1.5em'}}>
                            <LoadMore loading>Loading</LoadMore>
                        </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default connect((state) => ({
    redpackUserObject: state.redpack.redpackUserObject,
    redpackGrab: state.redpack.redpackGrab,
    showRedpackUserDialog: state.redpack.showRedpackUserDialog,
    message: state.redpack.redpackMessage,
    lecture: state.classroom.lecture,
}))(ClassroomRedpackUserDialog)


// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomRedpackUserDialog.js